module.exports = __webpack_public_path__ + "img/managed_service.a8d7fc7.png";